import { ProductControls } from "@components/product-input/product-controls.enum";

const commonControls: ProductControls[] = [
  ProductControls.ProductName,
  ProductControls.CommonName,
  ProductControls.Qty,
  ProductControls.IsPromoted,
  ProductControls.Tags,
  ProductControls.OriginCountryIso2,
  ProductControls.VendorId,
  ProductControls.Status,
  ProductControls.MoreDescription,
  ProductControls.IsFeatured,
  ProductControls.IsRareFish,
  ProductControls.AvailableInBuildAquarium,
  ProductControls.CategoryId,
  ProductControls.SubcategoryId,
  ProductControls.ProductMedia,
  ProductControls.ProductOptions,
];
export const livestockInputControls: ProductControls[] = [
  ...commonControls,
  ProductControls.MinSize,
  ProductControls.MaxSize,
  ProductControls.SubsubcategoryId,
  ProductControls.IsPreOrder,
  ProductControls.IsRequestQuote,
  ProductControls.ProductExpiry,
  ProductControls.Temperament,
  ProductControls.WaterCondition,
  ProductControls.Wysiwyg,
  ProductControls.AiTags,
];

export const tankInputControls: ProductControls[] = [
  ...commonControls.filter((c) => c !== ProductControls.IsRareFish),
  ProductControls.CapacityInGallons,
  ProductControls.TankLength,
  ProductControls.TankBreadth,
  ProductControls.TankHeight,
];

export const otherProductInputControls: ProductControls[] = [...commonControls];

/**
 * The two main categories that get a form of their own. A "segment" is which form
 * to show, not which category the product is saved under — several main
 * categories can share the livestock form.
 */
export const LIVESTOCK_SEGMENT = 1;
export const TANK_SEGMENT = 5;
export const OTHER_SEGMENT = 0;

/**
 * Is this main category livestock?
 *
 * Matched on the NAME, not the id, because there is more than one livestock
 * category and their ids differ per database — "Marine Livestock" is 240 in
 * production and does not exist in UAT at all. Naming is the one thing that is
 * stable across environments, and it keeps working when "Livestock" is renamed
 * to "Freshwater Livestock".
 */
export const isLivestockCategoryName = (name: string | undefined | null): boolean =>
  /livestock/i.test(name ?? "");

/**
 * Which form a category should use. Falls back to the id when no name is
 * available — callers that only hold an id still resolve the original Livestock
 * (1) and Tank (5) correctly.
 */
export const getSegmentForCategory = (
  categoryId: number,
  categories?: { id: number; name?: string }[]
): number => {
  const name = categories?.find((c) => c.id === categoryId)?.name;
  if (name !== undefined) {
    if (isLivestockCategoryName(name)) return LIVESTOCK_SEGMENT;
    return categoryId === TANK_SEGMENT ? TANK_SEGMENT : OTHER_SEGMENT;
  }
  if (categoryId === LIVESTOCK_SEGMENT) return LIVESTOCK_SEGMENT;
  if (categoryId === TANK_SEGMENT) return TANK_SEGMENT;
  return OTHER_SEGMENT;
};

export const getControlsForGeneralCategory = (
  categoryId: number,
  categories?: { id: number; name?: string }[]
) => {
  const segment = getSegmentForCategory(categoryId, categories);
  if (segment === LIVESTOCK_SEGMENT) {
    return {
      generalCategorySegment: LIVESTOCK_SEGMENT,
      controls: livestockInputControls,
      title: "Live Stock",
    };
  }
  if (segment === TANK_SEGMENT) {
    return {
      generalCategorySegment: TANK_SEGMENT,
      controls: tankInputControls,
      title: "Tank",
    };
  }
  return {
    generalCategorySegment: OTHER_SEGMENT,
    controls: otherProductInputControls,
    title: "Others",
  };
};
